import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { ChannelRead } from '../../models/channelDefinition.model';

import API from '../../services/api';

import channelKeys from './_queryKeys';

const getChannel = async (channelKey: string): Promise<ChannelRead> => {
    const { data } = await API.fetchChannel(channelKey);
    return data;
};

export default function useChannelDefinitionQuery(
    channelKey: string | undefined,
    enabled: boolean = true,
) {
    return useQuery<ChannelRead, BaseError>({
        queryKey: channelKeys.byKey(channelKey ?? ''),
        queryFn: () => getChannel(channelKey as string),
        enabled: !!channelKey && enabled,
        retry: false,
        meta: { skipGlobalErrorToast: true },
    });
}
